import degreeToRadian from '../degreeToRadian/index.js';

// https://math.stackexchange.com/questions/270194/how-to-find-the-vertices-angle-after-rotation
var sin = Math.sin,
    sqrt = Math.sqrt,
    pow = Math.pow,
    atan = Math.atan,
    cos = Math.cos;

var getNotRotatedCoords = function getNotRotatedCoords(_ref) {
  var x = _ref.x,
      y = _ref.y,
      rotation = _ref.rotation,
      width = _ref.width,
      height = _ref.height;
  var radius = sqrt(pow(width, 2) + pow(height, 2)) / 2;
  var diagonalAngle = atan(height / width) || 0;
  var rotationRadian = degreeToRadian(rotation);
  var sinRotation = sin(rotationRadian);
  var cosRotation = cos(rotationRadian);
  var centerX = x + radius * cos(diagonalAngle - rotationRadian) * Math.sign(width);
  var centerY = y + radius * sin(diagonalAngle - rotationRadian) * Math.sign(width);
  var topLeftX = ((x - centerX) * cosRotation - (y - centerY) * sinRotation + centerX * Math.sign(width)) * Math.sign(width);
  var topLeftY = ((x - centerX) * sinRotation + (y - centerY) * cosRotation + centerY * Math.sign(height)) * Math.sign(height);
  var notRotatedX = topLeftX - Number(width < 0) * width;
  var notRotatedY = topLeftY - Number(height < 0) * height;
  return {
    x: notRotatedX,
    y: notRotatedY,
    centerX: notRotatedX + width,
    centerY: notRotatedY + height
  };
};

export { getNotRotatedCoords as default };
